module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_05-7d48cc48d77bcf9ff89b968c0a820c9a.jpg";